import { FC, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import CheckMFA from './checkMFA';
import AppLoader from './components/AppLoader';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const AWS_RUM_CONFIGS: Record<
  string,
  { applicationId: string; identityPoolId: string; signing: boolean; pagesToInclude?: RegExp[] }
> = {
  poc: {
    applicationId: 'b3781f17-3155-4c56-9717-210dc21aa4fe',
    identityPoolId: 'eu-west-1:73f9ef89-221a-4846-a49d-c6fe68e485eb',
    signing: false,
    pagesToInclude: [/https:\/\/poc-my\.salecycle\.com\//],
  },
  production: {
    applicationId: 'd22c6b99-f8c3-4948-a9a8-403b465675ce',
    identityPoolId: 'eu-west-1:b6d2d016-9fe5-4018-b122-232e73ac5215',
    signing: true,
  },
};

const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'eu-west-1';

const initAwsRum = () => {
  const env = import.meta.env.VITE_ENV;
  const envConfig = env ? AWS_RUM_CONFIGS[env] : undefined;

  if (!envConfig) return;

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
      identityPoolId: envConfig.identityPoolId,
      signing: envConfig.signing,
      ...(envConfig.pagesToInclude && { pagesToInclude: envConfig.pagesToInclude }),
    };

    new AwsRum(envConfig.applicationId, APPLICATION_VERSION, APPLICATION_REGION, config);
  } catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};

initAwsRum();
/** Props inherited from Amplify */
interface InheritedProps {
  authState?: string;
}

type Props = InheritedProps;

export const App: FC<Props> = ({ authState }) => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={`${import.meta.env.BASE_URL}favicon-${import.meta.env.VITE_ENV}.svg`} />
        <title>
          {import.meta.env.VITE_ENV === 'production'
            ? 'My SaleCycle'
            : import.meta.env.VITE_ENV === 'development'
            ? 'Development'
            : 'POC'}
        </title>
      </Helmet>

      <Suspense fallback={<AppLoader showGradient={true} />}>
        <CheckMFA authState={authState} />
      </Suspense>
    </>
  );
};

export default App;
